import {faFilePlus} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Text} from '@rdcomponents/text/text';
import {Form, Upload} from 'antd';
import type {UploadProps} from 'antd/es/upload';
import type {RcFile} from 'antd/es/upload/interface';

import {ImportReviewsFormFieldNamesEnum, ImportReviewsFormFieldsType} from './import-reviews-form-type';
import * as styles from './import-reviews-file-dragger.module.scss';

const ACCEPTED_FILE_EXTENSIONS = '.csv,.xls,.xlsx';

type ImportReviewsFileDraggerPropsType = Pick<UploadProps<RcFile>, 'fileList' | 'onChange'>;

export function ImportReviewsFileDragger(props: ImportReviewsFileDraggerPropsType): JSX.Element {
    const {fileList: fileListValue, onChange} = props;

    const form = Form.useFormInstance<ImportReviewsFormFieldsType>();
    const fieldErrors = form.getFieldError(ImportReviewsFormFieldNamesEnum.reviewsFile);
    const hasFieldError = fieldErrors.length > 0;

    const fileList = (fileListValue ?? []).map((file) => (hasFieldError ? {...file, status: 'error' as const} : file));

    function handleChange(info: Parameters<NonNullable<UploadProps<RcFile>['onChange']>>[0]): void {
        if (hasFieldError) {
            form.setFields([{name: ImportReviewsFormFieldNamesEnum.reviewsFile, errors: []}]);
        }

        onChange?.(info);
    }

    return (
        <Upload.Dragger
            accept={ACCEPTED_FILE_EXTENSIONS}
            beforeUpload={() => false}
            className={styles.ImportReviewsFileDragger_dropzoneUpload}
            fileList={fileList}
            listType="text"
            maxCount={1}
            onChange={handleChange}
            showUploadList
        >
            <FontAwesomeIcon className={styles.ImportReviewsFileDragger_dropzoneIcon} icon={faFilePlus} />
            <div className={styles.ImportReviewsFileDragger_dropzoneHint}>
                <Text block small stringKey="REVIEW_IMPORT__FILE_UPLOAD_HINT" />
                <Text block small stringKey="REVIEW_IMPORT__FILE_UPLOAD_HINT__CSV" />
            </div>
        </Upload.Dragger>
    );
}
